import { FormContainer } from '@strata/react-form-container';
import { NumberInputFormik } from '@strata/react-inputs';
import { Spinner } from '@strata/react-loading-animation';
import { SuggestSingleSelectFormik } from '@strata/react-selects';
import { SuccessToast } from '@strata/react-toast-message';
import { validationStrings } from '@strata/strata-ui-strings';
import { Formik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';

import { putSetAuctionEndTime } from 'api/oopsAPI';
import { handleError } from 'services/Error';
import { useGetActiveAuctionsQuery } from 'store/api/oopsApi';

const ValidationSchema = Yup.object({
    referral_id: Yup.string().required(validationStrings.requiredField.errorMessage),
    minutes_offset: Yup.number().required(validationStrings.requiredField.errorMessage),
});

export const EditAuctionEnd = () => {
    const [adminLog, setAdminLog] = useState<string>();
    const { data: auctionsList, isFetching: auctionsListFetching } = useGetActiveAuctionsQuery();

    return (
        <Formik
            initialValues={{} as Yup.InferType<typeof ValidationSchema>}
            validationSchema={ValidationSchema}
            onSubmit={async (values) => {
                try {
                    const response = await putSetAuctionEndTime(values);
                    SuccessToast({ message: 'Auction End Time Updated.' });
                    setAdminLog(response);
                } catch (err) {
                    handleError('Error updating auction end time.', err as Error);
                }
            }}
        >
            {(formik) => (
                <FormContainer
                    formTitle="Edit Auction End Time"
                    primaryButtonLabel="Execute"
                    onFormSubmit={formik.handleSubmit}
                    isSubmitting={formik.isSubmitting || !(formik.dirty && formik.isValid)}
                    onCancelClick={formik.resetForm}
                    formLeftContent={
                        <>
                            <SuggestSingleSelectFormik
                                id="referral_id"
                                label="Auction Referral"
                                isLoading={auctionsListFetching}
                                values={auctionsList}
                                required
                                selectedItem={auctionsList?.find(
                                    ({ referral_id }) => referral_id === formik.values.referral_id,
                                )}
                                onChange={(newValue) => {
                                    void formik.setFieldValue('referral_id', newValue?.referral_id);
                                }}
                            />
                            <NumberInputFormik
                                id="minutes_offset"
                                label="End Time Minutes Offset"
                                required
                            />
                        </>
                    }
                    formRightContent={
                        <>
                            <div>Auction End Time:</div>
                            {formik.isSubmitting ? (
                                <Spinner intent={Spinner.Intent.NONE} />
                            ) : (
                                <pre>{adminLog && JSON.stringify(adminLog, null, 2)}</pre>
                            )}
                        </>
                    }
                />
            )}
        </Formik>
    );
};
